var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { id: "snb" } }, [
    _vm.isPageView([
      "viewFAQ",
      "viewFAQNew",
      "newQuestionList",
      "newQuestionConnect"
    ])
      ? _c("section", { staticClass: "snb_sec faq_inquiry" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY.TYPE")))]),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c(
              "ul",
              { staticClass: "list_inquiry" },
              _vm._l(_vm.supportSnb.faqInquiry, function(item) {
                return _c(
                  "li",
                  {
                    key:
                      _vm.pageName + item.INQUIRY_TYPE1 + item.INQUIRY_TYPE_NM1,
                    class: _vm.getSnbClass(item.INQUIRY_TYPE1)
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.snbClick(
                              $event,
                              item.INQUIRY_TYPE1,
                              "",
                              ""
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item.INQUIRY_TYPE_NM1) +
                            "\n                        "
                        ),
                        item.TOTAL_CNT &&
                        _vm.isPageView(["viewFAQ", "viewFAQNew"])
                          ? _c("em", [
                              _vm._v(
                                "\n                            (" +
                                  _vm._s(item.TOTAL_CNT) +
                                  ")\n                        "
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    !(
                      "ALL" === item.INQUIRY_TYPE1 ||
                      "ETC" === item.INQUIRY_TYPE1
                    )
                      ? _c(
                          "a",
                          {
                            staticClass: "ico_arrow",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.snbClick(
                                  $event,
                                  item.INQUIRY_TYPE1,
                                  "",
                                  "arrow"
                                )
                              }
                            }
                          },
                          [_c("span", { staticClass: "sr_only" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !(
                      "ALL" === item.INQUIRY_TYPE1 ||
                      "ETC" === item.INQUIRY_TYPE1
                    )
                      ? _c(
                          "ul",
                          _vm._l(item.faqSubInquiry, function(itemSub) {
                            return _c(
                              "li",
                              {
                                key:
                                  _vm.pageName +
                                  item.INQUIRY_TYPE1 +
                                  itemSub.INQUIRY_TYPE2,
                                on: {
                                  click: function($event) {
                                    return _vm.snbClick(
                                      $event,
                                      item.INQUIRY_TYPE1,
                                      itemSub.INQUIRY_TYPE2,
                                      ""
                                    )
                                  }
                                }
                              },
                              [
                                _c("a", { attrs: { href: "javascript:" } }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(itemSub.INQUIRY_TYPE_NM2) +
                                      "\n                                "
                                  ),
                                  itemSub.TOTAL_CNT &&
                                  _vm.isPageView(["viewFAQ", "viewFAQNew"])
                                    ? _c("em", [
                                        _vm._v(
                                          "\n                                    (" +
                                            _vm._s(itemSub.TOTAL_CNT) +
                                            ")\n                                "
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPageView(["createNewFAQ", "createNewQuestion"])
      ? _c("section", { staticClass: "snb_sec myctg_wrap" }, [
          _c("h2", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("FIELD.FAQ.INQUIRY.QUICK")) +
                "\n            "
            ),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c(
              "ul",
              { staticClass: "list_quick_inquiry" },
              _vm._l(_vm.supportSnb.faqQuickInquiryList, function(item) {
                return _c(
                  "li",
                  {
                    key:
                      _vm.pageName +
                      item.WORK_KEY_1 +
                      item.WORK_KEY_2 +
                      item.WORK_KEY_3 +
                      item.ROW_NUM
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.getQuickInquiryClick(
                              item.WORK_KEY_1,
                              item.WORK_KEY_2,
                              item.WORK_KEY_3
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getQuickName(
                                item.WORK_KEY_1_NM,
                                item.WORK_KEY_2_NM,
                                item.WORK_KEY_3_NM
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPageView([
      "viewFAQ",
      "viewFAQNew",
      "createNewFAQ",
      "newQuestionList",
      "newQuestionConnect",
      "createNewQuestion"
    ])
      ? _c("section", { staticClass: "snb_sec myctg_wrap" }, [
          _c("h2", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("TITLE.GLOBAL.QUICKCATEGORY")) +
                "\n            "
            ),
            _c(
              "a",
              {
                staticClass: "ico_config",
                attrs: {
                  href: "javascript:",
                  title: _vm.$t("BUTTON.GLOBAL.CONFIG")
                },
                on: { click: _vm.btnCatConfig }
              },
              [
                _c("span", { staticClass: "sr_only" }, [
                  _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c(
              "ul",
              { staticClass: "list_myctg" },
              _vm._l(_vm.supportSnb.faqQuickCategoryList, function(item) {
                return _c(
                  "li",
                  {
                    key:
                      _vm.pageName +
                      item.WORK_KEY_1 +
                      item.WORK_KEY_2 +
                      item.ROW_NUM
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.getQuickCategoryClick(
                              item.WORK_KEY_1,
                              item.WORK_KEY_2
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getQuickName(
                                item.WORK_KEY_1_NM,
                                item.WORK_KEY_2_NM
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPageView(["questionList", "answerList", "answerListNew"])
      ? _c("dl", { staticClass: "tree_wrap" }, [
          _c("dd", [
            _c("article", { staticClass: "tree_group" }, [
              _c("p", { staticClass: "tree_subtitle" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY.TYPE")))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "tree_list" },
                [
                  _c("label", { staticClass: "checkbox-wrap" }, [
                    _c("input", {
                      staticClass: "inquiry0",
                      attrs: {
                        type: "checkbox",
                        name: "all",
                        value: "all",
                        checked: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.treeChange($event, "All", "inquiry")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "check-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v("All")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.inquiryCodeList, function(item) {
                    return _c("li", { key: _vm.pageName + item.CD }, [
                      _c(
                        "a",
                        {
                          class: "ETC" === item.CD ? "" : "ico_tree",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.treeClick($event, item.subCodeList)
                            }
                          }
                        },
                        [_c("span", { staticClass: "sr_only" })]
                      ),
                      _vm._v(" "),
                      _c("label", { staticClass: "checkbox-wrap" }, [
                        _c("input", {
                          staticClass: "inquiry1",
                          attrs: {
                            type: "checkbox",
                            name: item.CD + "_all",
                            checked: ""
                          },
                          domProps: { value: item.CD },
                          on: {
                            change: function($event) {
                              return _vm.treeChange($event, item.CD)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "check-icon" }),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(item.CD_NAME))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          key: _vm.pageName + item.CD + _vm.inquiryCount,
                          staticClass: "tree_sub_list"
                        },
                        _vm._l(item.subCodeList, function(subCode) {
                          return _c(
                            "li",
                            { key: _vm.pageName + item.CD + subCode.CD },
                            [
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _c("input", {
                                  staticClass: "inquiry2",
                                  attrs: {
                                    type: "checkbox",
                                    name: item.CD,
                                    checked: ""
                                  },
                                  domProps: { value: subCode.CD },
                                  on: {
                                    change: function($event) {
                                      return _vm.treeChange(
                                        $event,
                                        item.CD,
                                        subCode.CD
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" }),
                                _vm._v(" "),
                                _c("em", [_vm._v(_vm._s(subCode.CD_NAME))])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "tree_group" }, [
              _c("p", { staticClass: "tree_subtitle" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "tree_list" },
                [
                  _c("label", { staticClass: "checkbox-wrap" }, [
                    _c("input", {
                      staticClass: "category0",
                      attrs: {
                        type: "checkbox",
                        name: "all",
                        value: "all",
                        checked: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.treeChange($event, "All", "category")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "check-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v("All")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.categoryCodeList, function(item) {
                    return _c("li", { key: _vm.pageName + item.code }, [
                      _c(
                        "a",
                        {
                          staticClass: "ico_tree",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.treeClick($event, item.subCodeList)
                            }
                          }
                        },
                        [_c("span", { staticClass: "sr_only" })]
                      ),
                      _vm._v(" "),
                      _c("label", { staticClass: "checkbox-wrap" }, [
                        _c("input", {
                          staticClass: "category1",
                          attrs: {
                            type: "checkbox",
                            name: item.code + "_all",
                            checked: ""
                          },
                          domProps: { value: item.code },
                          on: {
                            change: function($event) {
                              return _vm.treeChange($event, item.code)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "check-icon" }),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(item.codeName))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          key: _vm.pageName + item.code + _vm.inquiryCount,
                          staticClass: "tree_sub_list"
                        },
                        _vm._l(item.subCodeList, function(subCode) {
                          return _c(
                            "li",
                            { key: _vm.pageName + item.code + subCode.code },
                            [
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _c("input", {
                                  staticClass: "category2",
                                  attrs: {
                                    type: "checkbox",
                                    name: item.code,
                                    checked: ""
                                  },
                                  domProps: { value: subCode.code },
                                  on: {
                                    change: function($event) {
                                      return _vm.treeChange(
                                        $event,
                                        item.code,
                                        subCode.code
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" }),
                                _vm._v(" "),
                                _c("em", [_vm._v(_vm._s(subCode.codeName))])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "btn" }, [
            _c(
              "a",
              {
                staticClass: "btn_apply",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.applyClick()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.APPLY")))]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPageView(["questionDetail", "answerDetail"])
      ? _c(
          "ul",
          { staticClass: "status_wrap" },
          _vm._l(_vm.flowList, function(item) {
            return _c(
              "li",
              {
                key: _vm.pageName + item.QUESTION_FLOW_ID,
                class: _vm.getFlowClass(item.QNA_STATUS, item.FLOW_STATUS),
                on: {
                  click: function($event) {
                    return _vm.openUserDetail(
                      _vm.getQuestionId,
                      item.FLOW_STATUS,
                      item.USER_NO,
                      item.QUESTION_FLOW_ID,
                      "user"
                    )
                  }
                }
              },
              [
                _vm.isNull(item.MESSAGE) && 0 === item.COMMENT_CNT
                  ? _c("p", { staticClass: "item_status" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.QNA_STATUS_NM) +
                          "\n            "
                      )
                    ])
                  : _c("p", { staticClass: "item_status" }, [
                      _c(
                        "em",
                        {
                          on: {
                            click: function($event) {
                              _vm.openUserDetail(
                                _vm.getQuestionId,
                                item.FLOW_STATUS,
                                item.USER_NO,
                                item.QUESTION_FLOW_ID,
                                "comment",
                                $event.stopPropagation()
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.QNA_STATUS_NM) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                _vm._v(" "),
                _c("p", { staticClass: "item_name" }, [
                  _vm._v(_vm._s(item.ANSWERER_NM))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "item_group" }, [
                  _vm._v(_vm._s(item.ANSWERER_DEPT_NM))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "item_date" }, [
                  _vm._v(_vm._s(item.REG_DT))
                ])
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isPageView([
      "questionDetail",
      "answerDetail",
      "returnSystem",
      "newQuestionConnect"
    ])
      ? _c("section", { staticClass: "bn_wrap" }, [
          _c("ul", { staticClass: "list_banner" }, [
            _c("li", { staticClass: "bn_box" }, [
              _c(
                "a",
                {
                  staticClass: "ico_knowledge",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.btnSupport()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.KNOWLEDGE")) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "ico_config",
        attrs: { href: "javascript:", title: "config" }
      },
      [_c("span", { staticClass: "sr_only" }, [_vm._v("config")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bc8269b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc8269b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/common/faqSnb.vue
// module id = mdrd
// module chunks = 0